
export default class HistoryRoute{

    constructor(attrs) {
        this.get = 'history/'+attrs['parentSpace']+'/'+attrs['parentId'];
    }

}
